/**
 * Role-related translations for Chinese (Traditional) language
 * This file contains translations for role names and descriptions
 */
export default {
  roles: {
    merlin: '梅林',
    merlinPure: '終極梅林',
    guinevere: '女皇',
    percival: '派西維爾',
    tristan: '特里斯坦',
    isolde: '伊索德',
    troublemaker: '麻煩友',
    servant: '僕人',
    goodLancelot: '正義-蘭斯洛特',
    evilLancelot: '邪惡-蘭斯洛特',
    lancelots: '蘭斯洛特',
    mordred: '莫德雷德',
    trickster: '騙子',
    morgana: '莫甘娜',
    oberon: '奧伯倫',
    lunatic: '瘋子',
    brute: '野蠻人',
    witch: '巫婆',
    minion: '士兵',
    cleric: '牧師',
    revealer: '被揭示者',
    role: '角色',
    unknown: '未知角色',
    mysteryWizard: '神秘法師',
    unknownLancelot: '未知蘭斯洛特',
    wraith: '幽靈',
  },
  rolesInfo: {
    roles: '角色',
    inGameRoles: '遊戲中的角色',
    visibleRoles: '你可見的角色',
    merlinInfo: '知道誰是壞人方,必須保持隱藏',
    merlinPureInfo: '知道誰是壞人方及角色,必須保持隱藏',
    percivalInfo: '看到兩位角色(梅林/莫甘娜),但不知道誰是真正的梅林',
    servantInfo: '亞瑟王的忠實僕人',
    troublemakerInfo: '不得不對他的忠誠度撒謊',
    guinevereInfo: '看到兩位角色(蘭斯洛特),但不知道誰是真正的蘭斯洛特',
    goodLancelotInfo: '好人方的蘭斯洛特,可以從角色轉為壞人方',
    evilLancelotInfo: '壞人方的蘭斯洛特,可以從角色轉為好人方',
    mordredInfo: '梅林不知道你是壞人方',
    morganaInfo: '扮演梅林,混淆派西維爾',
    oberonInfo: '其他壞人方不知道你是壞人方',
    minionInfo: '莫德雷德的爪牙',
    isoldeInfo: '戀人,知道誰是特里斯坦,必須保持隱藏',
    tristanInfo: '戀人,知道誰是伊索德,必須保持隱藏',
    evilInfo: '角色未知的壞人方玩家',
    goodInfo: '角色未知的好人方玩家',
    tricksterInfo: '對他的忠誠撒謊',
    lunaticInfo: '每個任務都必須失敗',
    bruteInfo: '可能只會失敗前三個任務',
    witchInfo: '可以隱藏一次任務的結果，但這會給一個隨機玩家忠誠檢測',
    revealerInfo: '在第二次任務失敗後揭露自己',
    clericInfo: '知道第一次任務領導者的效忠情況。必須保持隱藏',
    unknownInfo: '未知角色',
    mysteryWizardInfo: '兩個玩家之一是好人方的(梅林)還是壞人的(莫甘娜)',
    unknownLancelotInfo: '蘭斯洛特,誰的忠誠無人知曉',
    wraithInfo: '壞人方和梅林都不知道你的存在',
  },
};
